"use client";

import { useEffect, useRef } from "react";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourPremierTransportationSolution() {
  const parallaxRef = useRef<HTMLDivElement>(null);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrolled = window.scrollY;
        parallaxRef.current.style.transform = `translateY(${scrolled * 0.15}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section className="relative w-full h-screen overflow-hidden">
      {}
      <div ref={parallaxRef} className="absolute inset-0 w-full h-[120%] bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/luxury_sedan_dusk_hero.png)]" style={{
      willChange: "transform"
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-background/60 to-background/80" />

      {}
      <div ref={contentRef} className="relative z-10 flex flex-col items-center justify-center h-full px-4 sm:px-6 lg:px-8">
        <div className={`max-w-4xl text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-dark mb-6 leading-tight">Car Service Connecticut — Your #1 Choice for Airport &amp; City-to-City Transportation</h1>

          {}
          <p className="text-lg sm:text-xl md:text-2xl text-foreground-dark/90 mb-10 max-w-2xl mx-auto font-sans">Reliable car service to and from NYC, JFK, LGA, and all major Connecticut locations.</p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="https://book.mylimobiz.com/v4/CSC">
              <Button size="lg" className="btn-primary group relative animate-pulse hover:animate-none px-8 py-4 text-base sm:text-lg bg-accent text-foreground-accent hover:bg-accent-hover">
                Book Your Ride or Get An Instant Quote
                <ArrowRight className="ml-2 transition-transform duration-[var(--duration-medium)] group-hover:translate-x-1" />
              </Button>
            </Link>

            <Link to="tel:(203) 872-9965">
              <Button size="lg" className="btn-primary group px-8 py-4 text-base sm:text-lg bg-accent text-foreground-accent hover:bg-accent-hover">
                Call Now: (203) 872-9965
                <Phone className="mr-2 transition-transform duration-[var(--duration-medium)] group-hover:scale-110" />
              </Button>
            </Link>
          </div>

          {}
          <div className="mt-12 flex flex-wrap justify-center gap-6 text-foreground-dark/80 text-sm sm:text-base">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-accent" />
              <span>24/7 Availability</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-accent" />
              <span>Professional Drivers</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-accent" />
              <span>Luxury Fleet</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}